import React from 'react';
import { Mail, Phone, MapPin, Clock, ArrowRight, Linkedin } from 'lucide-react';
import { useSeo } from '../hooks/useSeo';
import { Contact } from './Contact';

const INFOS = [
  { icon: Mail, label: 'E-mail', value: 'tommy@jenmaconcept.com', href: 'mailto:tommy@jenmaconcept.com' },
  { icon: Phone, label: 'Téléphone', value: '06 95 76 71 00', href: 'tel:+33695767100' },
  { icon: MapPin, label: 'Siège', value: 'Salon-de-Provence (13300), France' },
  { icon: MapPin, label: "Zone d'intervention", value: "Provence-Alpes-Côte d'Azur · Paris · France sur demande" },
  { icon: Clock, label: 'Horaires', value: 'Lundi au vendredi · 9h-12h et 14h-18h' },
];
const SERVICES = ["Conseil en agencement et analyse d'espace", 'Dessin technique et plans cotés', 'Modélisation 3D et rendus', 'Suivi de chantier et coordination des artisans', 'Agencement complet, résidentiel ou professionnel'];

export default function ContactPage() {
  useSeo('Contact - Parlons de votre projet', "Contactez JENMA Concept pour votre projet d'agencement intérieur haut de gamme depuis Salon-de-Provence, en Provence-Alpes-Côte d'Azur et à Paris. Réponse sous 48 h ouvrées.", '/contact');
  return (
    <div className="bg-[#121212] text-gray-200" data-testid="contact-page">
      <section className="pt-36 lg:pt-48 pb-16 container mx-auto px-6">
        <p className="text-[11px] uppercase tracking-[0.4em] text-gold mb-5 flex items-center gap-3"><span className="w-10 h-px bg-gold" />Contact</p>
        <h1 className="font-playfair text-4xl sm:text-5xl lg:text-6xl text-white max-w-3xl leading-tight">Parlons de <em className="text-[#d9c3a0]">votre projet</em></h1>
        <p className="text-gray-400 mt-6 max-w-2xl">Que vous ayez un projet résidentiel ou professionnel, nous sommes à votre écoute pour transformer vos espaces avec précision et élégance. Réponse sous 48 heures ouvrées ; pour une demande urgente, privilégiez le téléphone.</p>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-14">
          {INFOS.map(({ icon: Icon, label, value, href }) => {
            const Tag = href ? 'a' : 'div';
            return (
              <Tag key={label} href={href} data-testid={`contact-info-${label}`} className="group border border-white/10 hover:border-gold/60 p-6 transition-colors duration-300">
                <Icon className="w-5 h-5 text-gold mb-4" />
                <p className="text-[10px] uppercase tracking-[0.3em] text-gray-500 mb-1">{label}</p>
                <p className="text-white text-sm group-hover:text-gold transition-colors">{value}</p>
              </Tag>
            );
          })}
        </div>
        <div className="grid lg:grid-cols-2 gap-10 mt-16">
          <div>
            <h2 className="font-playfair text-2xl text-white mb-5">Ce que vous pouvez nous demander</h2>
            <ul className="space-y-3">{SERVICES.map((s) => <li key={s} className="flex gap-3 text-gray-400 text-sm"><span className="w-1.5 h-1.5 bg-neon rounded-full mt-2 shrink-0" />{s}</li>)}</ul>
          </div>
          <div className="border border-gold/20 p-8 bg-[#171717]">
            <h2 className="font-playfair text-2xl text-white mb-3">Esquissez votre idée en 5 minutes</h2>
            <p className="text-gray-400 text-sm mb-6">Composez votre cuisine, dressing ou salle de bain dans notre configurateur : plan, élévation et perspective vous sont envoyés en PDF.</p>
            <div className="flex flex-wrap gap-3">
              <a href="/configurateur" data-testid="contact-page-configurator" className="group inline-flex items-center gap-2 bg-gold hover:bg-gold-light text-dark font-semibold px-6 py-3 transition-colors">Ouvrir le configurateur <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" /></a>
              <a href="https://fr.linkedin.com/in/tommy-saadoun-b724a94a" target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 border border-white/15 hover:border-gold text-gray-300 px-6 py-3 transition-colors"><Linkedin className="w-4 h-4" />LinkedIn</a>
            </div>
          </div>
        </div>
      </section>
      <Contact formOnly />
    </div>
  );
}
